export default {
      id: "DMS-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#DMS",
      toString: function () {
        return this.url;
      }
    }